import { useHover } from "@mantine/hooks";
import { Fragment } from "react";

import BackgroundWrapper from "_components/atoms/backgroundWrapper";
import Typography        from "_components/atoms/typography";

import useStyles from "./styles";

const FAQ = props => {
	const {
		onLinkClick
	} = props;
	const { classes } = useStyles ( undefined, { name: "styles" } );

	const faqData = [
		{
			title : "Browse FAQs",
			id    : "faq"
		},
		// {
		// title : "Watch Help Videos",
		// id    : "videos"
		// },
		{
			title : "Contact Rooter Support",
			id    : "support"
		}
	];

	return (
		<BackgroundWrapper
			className = { classes.faqRoot }
			type      = "primary"
		>
			<Typography
				className = { classes.faqTitle }
				title     = "Help & Support"
			/>

			<div className = { classes.contentDiv }>
				{
					faqData.map ( ( data, index ) => (
						<Fragment key = { index }>
							<FAQItems
								data        = { data }
								onLinkClick = { onLinkClick }
							/>
						</Fragment>
					) )
				}

			</div>
		</BackgroundWrapper>
	);
};

export default FAQ;
const FAQItems = ( { data, onLinkClick } ) => {

	const { hovered, ref } = useHover ();
	const { classes }      = useStyles ( { hovered } );

	return (
		<div
			ref       = { ref }
			className = { classes.faqQuestion }
			onClick   = { () => onLinkClick ( data.id ) }
			rel       = "noopener noreferrer"
			target    = "_blank"
		>
			<Typography
				title = { data?.title }
			/>

		</div>
	);
};
